var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight01 = function SvgArrowRight01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 19.86,
    y1: 151.51,
    x2: 213,
    y2: 54.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.68,96.8h0l-45.45-45.45c-1.63-1.91-4.5-2.13-6.41-.5-1.91,1.63-2.13,4.5-.5,6.41.15.18.32.34.5.5l37.68,37.73H4.55C2.04,95.48,0,97.51,0,100.02s2.04,4.55,4.55,4.55h179.95l-37.68,37.68c-1.91,1.63-2.13,4.5-.5,6.41,1.63,1.91,4.5,2.13,6.41.5.18-.15.34-.32.5-.5l45.45-45.45c1.76-1.77,1.76-4.64,0-6.41Z"
  })));
};
export default SvgArrowRight01;